export default __webpack_public_path__ + "static/media/dropdown.0bd69ecf.svg";